import React from 'react'
import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux';

import Swal from 'sweetalert2';

import { startRegister } from '../../actions/auth';
import { useForm } from '../../hooks/useForm';

export const RegisterScreen = () => {

    const dispatch = useDispatch()
    

    const [ formValues, handleInputChange ] = useForm( {
        Name: '',
        Email: '',
        Password1: '',
        Password2: ''
    });

    const { Name, Email, Password1, Password2 } = formValues;

    const handleRegister = ( e ) => {
        e.preventDefault()

        if ( Password1 !== Password2 ){
            return Swal.fire( 'Error', 'Las contraseñas deben ser iguales', 'error')
        }
       
        dispatch(startRegister( Email, Password1 , Name))

        
    }

  return (
    <div className='_auth'>
        <form onSubmit={ handleRegister }  className="container row">
            <div className="col-12 col-lg-4">

                    <h3>Registro</h3>
                    <hr />
                        <label htmlFor="nombre">Ingrese su nombre de usuario</label>
                        <input
                            id='nombre'
                            type="text"
                            className="form-control mt-1"
                            placeholder="Nombre"
                            name= 'Name'
                            value={ Name }
                            onChange={ handleInputChange }
                            autoComplete= "off"
                        />
                    
                    <div className=" mt-2">
                        <label htmlFor="email">Ingrese un email</label>
                        <input
                            id='email'
                            type="email"
                            className="form-control mt-1"
                            placeholder="Correo"
                            name= 'Email'
                            value={ Email }
                            onChange={ handleInputChange }
                        />
                    </div>
                    <div className=" mt-2">
                        <label htmlFor="password">Ingrese una contraseña</label>
                        <input
                            id='password'
                            type="password"
                            className="form-control mt-1"
                            placeholder="Contraseña" 
                            name= 'Password1'
                            value={ Password1 }
                            onChange={ handleInputChange }
                        />
                    </div>

                    <div className=" mt-2">
                        <label htmlFor="password2">Repita la contraseña</label>
                        <input
                            id='password2'
                            type="password"
                            className="form-control mt-1"
                            placeholder="Repita la contraseña" 
                            name= 'Password2'
                            value={ Password2 }
                            onChange={ handleInputChange }
                        />
                    </div>

                    <div className="submit mt-4">
                        <input 
                            type="submit" 
                            className="btn_blue" 
                            value="Crear cuenta" />
                            { !localStorage.getItem('token')&&
                            
                              <p className='mt-2'>ya tenés una cuenta? <Link to="/login" className='nav-menu-items register'> Inicia Sesión! <i className="fa-solid fa-right-to-bracket"></i></Link></p> 
                            }
                    </div>

            </div>
        </form>




    </div>
  )
}
